import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import './Footer.css'
import { FaFacebookF, FaInstagram, } from 'react-icons/fa';

const Footer = () => {
  return (
    <>
    <Container fluid className="foter align-items-center bg-black footer social-icons">
        
    <div className='h3 mt-3 d-inline-flex' >
                                    <a href='https://www.facebook.com/topqualitypatches' className='fb-Hvr text-white me-3'><FaFacebookF/></a>
                                    <a href='https://www.instagram.com/topqualitypatches_official/#' className='insta-Hvr text-white me-3'><FaInstagram/></a>
                                </div>
                  <div className='text-center h6 mt-3'>
                   Copyright © 2018 Top Quality Patches | Powered by Top Quality Patches
                  </div>
    </Container>
    </>
  )
}

export default Footer